module.exports = new __parcel__URL__("whats-cvc-card.a9e719bc.svg").toString();